import t from "./_nativeCreate.js";
function e() {
  this.__data__ = t ? t(null) : {}, this.size = 0;
}
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_hashClear.js
// module id = 1474
// module chunks = 41